import {bez} from "./../libs/bez";

export function ourCoursesSlider() {
  let slider = $(".our-courses-slider");
  let title = slider.find("h5, .h5, .terms");
  let more = slider.find(".more");

  more.eq(0).addClass("animated");

  slider.slick({
    centerMode: true,
    centerPadding: "20px",
    slidesToShow: 2,
    slidesToScroll: 2,
    speed: 350,
    arrows: true,
    cssEase: "cubic-bezier(.38,.01,.34,1)",
    //useCSS: false,
    prevArrow: `<button class="slick-arrow slick-prev">
            <svg class="arrow-left @@if(context.isReverse){reverse}" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            viewBox="0 0 17.6 8.2" style="enable-background:new 0 0 17.6 8.2;" xml:space="preserve">
            <polygon points="17.6,3.2 3.8,3.2 5.5,1.4 4.1,0 0,4.1 3.9,8.2 5.4,6.8 3.8,5.2 17.6,5.2 "/>
            </svg></button>`,
    nextArrow: `<button class="slick-arrow slick-next">
            <svg class="arrow-left @@if(context.isReverse){reverse}" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            viewBox="0 0 17.6 8.2" style="enable-background:new 0 0 17.6 8.2;" xml:space="preserve">
            <polygon points="17.6,3.2 3.8,3.2 5.5,1.4 4.1,0 0,4.1 3.9,8.2 5.4,6.8 3.8,5.2 17.6,5.2 "/>
            </svg></button>`,
    responsive: [
      {
        breakpoint: 26000,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: "0",
          infinite: false,
          variableWidth: true
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: "0",
          infinite: false
        }
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: "0",
          infinite: false
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false
        }
      }
    ]
  }).on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    let isNext = nextSlide > currentSlide;
    let currentSlideObj = $(`[data-slick-index=${currentSlide}]`);

    if (isNext) {
      currentSlideObj.addClass("move-slide active-slide");
    } else {
      currentSlideObj.prev().removeClass("move-slide").removeClass("hidden").removeClass("hide-text");
    }

    more.removeClass("animated");

    title.animate({
      top: "30px",
      left: "50px",
      opacity: 0
    }, 200, $.bez([.38, .01, .34, 1]), function () {
      slider.addClass("show");

      let _this = $(this);
      let slide = _this.closest(".slick-slide");

      if (slide.is(`[data-slick-index=${nextSlide}]`)) {
        slide.find(".more").addClass("animated");
      }

      if (isNext && slide.is(`[data-slick-index=${currentSlide}]`)) {
        slide.addClass("hide-text");
      }

      _this.removeAttr("style").animate({
        top: 0,
        left: 0,
        opacity: 1
      }, 200, $.bez([.38, .01, .34, 1]), function () {
        slider.removeClass("show");
        $(this).removeAttr("style");
      });

    });

  }).on("afterChange", function (event, slick, currentSlide) {
    $(`[data-slick-index=${currentSlide}]`).removeClass("active-slide");
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/ourCoursesSlider.js